import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Logo from "./Logo";

const Footer = () => {
  const phoneNumber = "05075537051";

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Logo light />
            <p className="text-slate-300 text-sm leading-relaxed">
              İstanbul'da ikinci el beyaz eşya, televizyon ve elektronik eşya alım satımında güvenilir adresiniz. Sıfır, ikinci el ve defolu tüm eşyalarınızı nakit karşılığında satın alıyoruz.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Hızlı Bağlantılar</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-white transition-colors text-sm">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-slate-300 hover:text-white transition-colors text-sm">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz" className="text-slate-300 hover:text-white transition-colors text-sm">
                  Hizmetlerimiz
                </Link>
              </li>
              <li>
                <Link to="/satin-aldigimiz-esyalar" className="text-slate-300 hover:text-white transition-colors text-sm">
                  Satın Aldığımız Eşyalar
                </Link>
              </li>
              <li>
                <Link to="/sss" className="text-slate-300 hover:text-white transition-colors text-sm">
                  Sık Sorulan Sorular
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-slate-300 hover:text-white transition-colors text-sm">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Hizmetlerimiz</h3>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>İkinci El Beyaz Eşya Alımı</li>
              <li>İkinci El Televizyon Alımı</li>
              <li>İkinci El Led TV Alımı</li>
              <li>İkinci El Elektronik Eşya Alımı</li>
              <li>Defolu Eşya Alımı</li>
              <li>Sıfır Eşya Alımı</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">İletişim</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-slate-300">
                <Phone className="w-5 h-5 text-[#25D366]" />
                <a href={`tel:${phoneNumber}`} className="hover:text-white transition-colors text-sm">
                  0507 553 70 51
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <MapPin className="w-5 h-5 text-[#002FA7]" />
                <span className="text-sm">İstanbul, Türkiye</span>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <Clock className="w-5 h-5 text-[#FF3B30]" />
                <span className="text-sm">7/24 Hizmet</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Beyaz Eşya Al Sat. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-4 text-sm text-slate-400">
              <span>İkinci el beyaz eşya alan yerler</span>
              <span className="hidden md:inline">•</span>
              <span className="hidden md:inline">İkinci el televizyon alanlar</span>
            </div>
          </div>
        </div>
      </div>

      {/* SEO Keywords - Hidden but accessible */}
      <div className="sr-only">
        <p>İkinci el beyaz eşya alan yerler, ikinci el beyaz eşya alanlar, ikinci el televizyon alan yerler, ikinci el televizyon alanlar, ikinci el led tv alan yerler, ikinci el led tv alanlar, ikinci el elektronik eşya alan yerler, ikinci el elektronik eşya alanlar. İstanbul'da ikinci el eşya alım satım.</p>
      </div>
    </footer>
  );
};

export default Footer;
